import warning from '../../images/warning.png';
import '../../styles/Styles.css';

const ErrorComp = () => {

    const handleRefresh = () => {
        window.location.reload();
    };

    return (
        <div className="error-container recaptcha-container">
            <img src={warning} alt='warning-icon' className='captcha-warning-icon'/>
            <div className="error-message recaptcha-error">
                We Can't Process Your Request. Please Try Again Later.
            </div>
            <button onClick={handleRefresh} className="form-button" id="refreshBtn">Refresh</button>
        </div>
    );

    <div>
        <p>
            
        </p>
    </div>
}

export default ErrorComp;